module.exports = __webpack_public_path__ + "static/media/002.83afdac1.jpeg";